import { Modifier } from '../modifier';
import { ModifierPriority, ModifierTags, StatusEffect } from '../modifier.type';
import { StatusEffectRegistry } from '../status-effects';

export class Ward extends Modifier {
  static readonly baseTitle = 'Ward';
  static readonly baseText = 'Reduce incoming Bane by stacks and reduce stacks by the same amount.';
  static readonly baseIcon = 'ward';
  static readonly baseTags = [ModifierTags.Boon];
  static readonly basePriority = ModifierPriority.Early;

  // Instance properties that can change
  title = Ward.baseTitle;
  text = Ward.baseText;
  icon = Ward.baseIcon;
  tags: Array<ModifierTags> = [...Ward.baseTags];
  priority = Ward.basePriority;

  modifierAdd(type: StatusEffect, stacks: number) {
    const modifier = StatusEffectRegistry.create(type, this.owner, 0);
    if (modifier.tags.includes(ModifierTags.Bane)) {
      let difference = this.stacks - stacks;
      this.removeStacks(Math.min(this.stacks, stacks));

      if (difference >= 0) {
        stacks = 0;
      } else {
        stacks = Math.abs(difference);
      }
    }
    return stacks;
  }
}

// Register the status effect
StatusEffectRegistry.register(StatusEffect.Ward, Ward);
